// extracted by mini-css-extract-plugin
export default {"checkboxOption":"styles_checkboxOption__1mcRo","full":"styles_full__nUnr+"};